import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { ShieldAlert } from "lucide-react";

export const ThreatHorizon = ({ brandName, points }) => {
  const data = points.map((d) => ({
    date: new Date(d.created_at).toLocaleDateString(undefined, { month: "short", day: "numeric" }),
    official: d.official_sentiment,
    fringe: d.fringe_sentiment,
    isRisk: d.is_risk,
  }));
  const currentRisk = points[points.length - 1]?.is_risk;

  return (
    <div className="rounded-lg border border-warning-amber/30 bg-warning-amber/5 p-4" data-testid={`threat-horizon-${brandName}`}>
      <div className="mb-2 flex items-center justify-between">
        <p className="text-sm font-semibold text-white">{brandName} &mdash; Threat Horizon</p>
        {currentRisk && (
          <span className="flex items-center gap-1 rounded-full bg-sovereign/20 px-2 py-0.5 text-[10px] font-bold uppercase text-sovereign" data-testid={`unreported-risk-badge-${brandName}`}>
            <ShieldAlert className="h-3 w-3" /> Unreported Risk
          </span>
        )}
      </div>
      <ResponsiveContainer width="100%" height={160}>
        <LineChart data={data}>
          <CartesianGrid stroke="#1E293B" strokeDasharray="3 3" />
          <XAxis dataKey="date" stroke="#64748B" fontSize={11} />
          <YAxis domain={[0, 100]} stroke="#64748B" fontSize={11} width={28} />
          <Tooltip contentStyle={{ background: "#0F1420", border: "1px solid #1E293B", fontSize: 12 }} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <Line type="monotone" dataKey="official" name="Official News" stroke="#00F2FE" strokeWidth={2} dot={{ r: 2 }} />
          <Line type="monotone" dataKey="fringe" name="Fringe/Social (AI-est.)" stroke="#F59E0B" strokeWidth={2} dot={{ r: 2 }} />
        </LineChart>
      </ResponsiveContainer>
      <p className="mt-2 text-[11px] text-slate-500">AI-estimated sentiment proxy, not live social-media data.</p>
    </div>
  );
};
